import * as process from 'process';
(window as any)['process'] = process;
